import { render, staticRenderFns } from "./SlideGroup.vue?vue&type=template&id=586fcbb5"
import script from "./SlideGroup.vue?vue&type=script&lang=js"
export * from "./SlideGroup.vue?vue&type=script&lang=js"
import style0 from "./SlideGroup.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports